import { Controller } from '@hotwired/stimulus';

// reCAPTCHA v3 のトークンをフォーム送信前に取得して hidden へ入れる (#1687 / #3116)。
//
// recaptcha gem が action ごとに window.executeRecaptchaFor<Action>Async を生成する
// ため、action 名から関数名を組み立てて呼ぶ。actionValue は recaptcha_v3 に渡した
// action と同じ綴りにすること。
//
// トークン取得は非同期なので、一度 submit を止めてから改めて form.submit() する。
// このとき submit イベントは再発火しないため、トークン取得済みの二重実行は起きない。
export default class extends Controller {
  static values = { action: String };

  async execute(event) {
    const input = this.tokenInput();
    // 本番以外では recaptcha_v3 を描画しないため hidden が無い。素通しする。
    if (!input) return;
    // 取得済みなら通常の送信に任せる (form.submit() 後の再入を含む)。
    if (input.value) return;

    event.preventDefault();
    try {
      input.value = await this.executor();
    } catch (err) {
      console.error('reCAPTCHA error:', err);
    }
    this.element.submit();
  }

  // hidden は recaptcha gem が生成するため data 属性を差し込めない
  // (gem は data を素通しせず data="{...}" という壊れた属性にしてしまう)。
  // gem が必ず付ける class を手がかりにする。
  tokenInput() {
    return this.element.querySelector('input.g-recaptcha-response');
  }

  // window.executeRecaptchaForLoginAsync のような gem 生成の関数を名前で引く。
  executor() {
    const name = `executeRecaptchaFor${this.sanitizeAction(this.actionValue)}Async`;
    const fn = window[name];
    if (typeof fn !== 'function') {
      return Promise.reject(new Error(`${name} is not defined`));
    }
    return fn();
  }

  // recaptcha gem の sanitize_action_for_js と同じ綴りにする。gem 側は
  // action.gsub(/\W/, '_').split(/\/|_/).map(&:capitalize).join なので、
  // password_reset は PasswordReset になる (Password_reset ではない)。
  sanitizeAction(action) {
    return String(action)
      .replace(/\W/g, '_')
      .split(/[/_]/)
      .filter((part) => part.length > 0)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join('');
  }
}
